import type { ActionFormResourceDetails } from 'react-components/dialog-forms/components/useNeedActionFormtypes';
import type { CboResourceFormValues } from './cboResourceForm.schema';

/**
 * Returns whether a resource entry should be upserted to `cbo_record` / `cbo_usage`.
 *
 * @param entry - Need-action row or CBO form values.
 * @returns False for explicitly custom (manual) resources.
 */
export function shouldPersistCboRecord(
  entry: Pick<ActionFormResourceDetails, 'isCustomResource'> | Pick<
    CboResourceFormValues,
    'isCustomResource'
  >
): boolean {
  return !entry.isCustomResource;
}
